/**
 * Support for Typescript based custom core widgets
 */

import Context from "../context/Context";
import RouteResult from "../components/main/Directions/RouteResult";
import _Topic from "../context/Topic";
import * as aiimUtil from "../aiim/util/aiimUtil";
import * as hitTest from "../aiim/util/hitTest";
import * as viewUtil from "./viewUtil";

export const Topic = _Topic;

export function fixHitZ(hit) {
  if (hit && hit.source && hit.feature) {
    const levels = Context.getInstance().aiim.datasets.levels;
    if (levels) levels.fixZ(hit.source,hit.feature);
  }
}

export function fixSearchZ(search,selectedResult) {
  if (search && search.sources && selectedResult && selectedResult.feature) {
    if (typeof selectedResult.sourceIndex === "number") {
      const src = search.sources.getItemAt(selectedResult.sourceIndex);
      if (src && typeof src.aiimKey === "string") {
        const categories = Context.getInstance().aiim.datasets.categories;
        const levels = Context.getInstance().aiim.datasets.levels;
        const source = categories.findSourceByKey(src.aiimKey);
        if (levels) levels.fixZ(source,selectedResult.feature);
      }
    }
  }
}

export function getViewUtil() {
  return viewUtil;
}

export function hitTestSearch(view,event,allowNonAiim) {
  return hitTest.search(view,event,allowNonAiim);
}

export function newRouteResult(props) {
  return new RouteResult(props);
}

export function removeShapeAttributes(attributes) {
  aiimUtil.removeShapeAttributes(attributes);
}
